/**
 * @file 哈勃 SDK
 * @author dafo<huanghouin@baijiahulian.com>
 */
import { setConfig, initExtraData } from './util/config';
import click from './click';
import perf from './perf';
import scroll from './scroll';
import view from './view';
import stay from './stay';
import video from './video';
import timing, { time, timeEnd } from './time';
import error from './error';
initExtraData();
/**
 * @name habo
 * @type {Object}
 * @property {Function} setConfig {@link module:config.setConfig}
 * @property {Function} click {@link module:module/click~report}
 * @property {Function} perf {@link module:module/perf~report}
 * @property {Function} scroll {@link module:module/scroll~report}
 * @property {Function} view {@link module:module/view~report}
 * @property {Function} stay {@link module:module/stay~report}
 * @property {Function} video {@link module:module/video~report}
 * @property {Function} timing {@link module:module/timing~report}
 * @property {Function} time {@link module:module/timing.time}
 * @property {Function} timeEnd {@link module:module/timing.timeEnd}
 */

export default {
  setConfig: setConfig,
  click: click,
  perf: perf,
  scroll: scroll,
  view: view,
  stay: stay,
  video: video,
  error: error,
  timing: timing,
  time: time,
  timeEnd: timeEnd,
  version: "2.1.4"
};